import { RelationType } from "Infrastructure/Api/Api";
import { z } from "zod";

export const relatedPartySchema = z.object({
  publicID: z.string().nullish(),
  relationType: z.enum(RelationType),
  relatedPartyPublicID: z.string(),
});
